{
  "fr": {
    "gallery": {
      "headers": {
        "subtitle": "Comment souhaitez-vous travailler aujourd'hui ?",
        "title": "Trouvez du matériel pédagogique prêt à l'emploi en tant que OER"
      }
    }
  }
}
